"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectLifecycleResultByChunks = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const async_1 = __importDefault(require("async"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const LifecycleGranularityJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleGranularityJSONModel");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const getNumberOfChunksByLastNDays = (lastNDays) => {
    if (lastNDays >= 180) {
        return 64;
    }
    if (lastNDays >= 90) {
        return 32;
    }
    if (lastNDays >= 60) {
        return 16;
    }
    if (lastNDays >= 30) {
        return 8;
    }
    if (lastNDays >= 15) {
        return 4;
    }
    return 2;
};
const getProjectLifecycleResultByChunks = async (actors, accessToken, lastNDays, granularity) => {
    return new Promise((resolve) => {
        // if (process.env.NODE_ENV === "development") {
        //     console.log("LifecycleApiService.getProjectLifecycleResultByChunks!!!! lastNDays", lastNDays, "granularity", granularity);
        // }
        const numberOfChunksByLastNDays = getNumberOfChunksByLastNDays(lastNDays);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectLifecycleResultByChunks numberOfChunksByLastNDays", { lastNDays, numberOfChunksByLastNDays });
        }
        const ranges = (0, ICCanisterUtils_1.splitPartitionsCountIntoChunks)(numberOfChunksByLastNDays, ICCanisterUtils_1.USERS_PARTITIONS_COUNT);
        // if (process.env.NODE_ENV === "development") {
        //     _.each(ranges, range => {
        //         const numbers = _.range(range.start, range.start + range.length);
        //         const numbersStart = (numbers+"").substring(0, 10)
        //         const numbersEnd = (numbers+"").substr(-10)
        //         console.log(`range: ${range.start}-${range.length}: (${numbers.length}) ${numbersStart} ... ${numbersEnd}`)
        //     })
        //     console.log("ranges", ranges);
        // }
        const getPromise = async (actor, range) => {
            switch (granularity) {
                case LifecycleGranularityJSONModel_1.Granularity.daily: {
                    return AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectLifecycleChunkDay(actor, accessToken, { lastNDays: lastNDays, partitionsRange: range });
                }
                case LifecycleGranularityJSONModel_1.Granularity.weekly: {
                    return AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectLifecycleChunkWeek(actor, accessToken, { lastNDays: lastNDays, partitionsRange: range });
                }
                case LifecycleGranularityJSONModel_1.Granularity.monthly: {
                    return AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectLifecycleChunkMonth(actor, accessToken, { lastNDays: lastNDays, partitionsRange: range });
                }
            }
        };
        const tasks = lodash_1.default.flatten(lodash_1.default.map(actors, (actor, actorIdx) => {
            return lodash_1.default.flatten(lodash_1.default.map(ranges, (range, rangeIdx) => {
                const cumulativeIdx = ranges.length * actorIdx + rangeIdx;
                return (callback) => {
                    (async () => {
                        try {
                            const result = await getPromise(actor, range);
                            const taskResult = { idx: cumulativeIdx, actorIndex: actorIdx, chunk: result };
                            callback(null, taskResult);
                        }
                        catch (e) {
                            callback(e);
                        }
                    })();
                };
            }));
        }));
        async_1.default.parallelLimit(tasks, 10, (err, results) => {
            if (!lodash_1.default.isNil(err)) {
                console.warn("getProjectLifecycleChunk promises failure: at least one of the chunks failed", err);
                resolve({ err: { "temporarilyUnavailable": null } });
            }
            else {
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("getProjectLifecycleChunk promises results", results);
                }
                try {
                    const tasksResult = results;
                    const thereAreErrors = lodash_1.default.some(tasksResult, (taskResult) => {
                        if ((taskResult === null || taskResult === void 0 ? void 0 : taskResult.chunk) == undefined) {
                            return true;
                        }
                        return (0, ICCanisterUtils_1.isICRequestErr)(taskResult.chunk);
                    });
                    if (thereAreErrors) {
                        console.warn("getProjectLifecycleChunk promises failure: there are backend errors", tasksResult);
                        resolve({ err: { "temporarilyUnavailable": null } });
                        return;
                    }
                    else {
                        //all chunk errors (by checking "isICRequestErr") made above. So here all variants are "#ok".
                        const lifecycleChartResultDataArray = lodash_1.default.compact(lodash_1.default.map(tasksResult, (taskResult) => {
                            if (taskResult != undefined && (0, ICCanisterUtils_1.isICRequestOk)(taskResult.chunk)) {
                                return {
                                    idx: taskResult.idx,
                                    actorIndex: taskResult.actorIndex,
                                    chunkData: taskResult.chunk.ok
                                };
                            }
                        }));
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("getProjectLifecycleChunk promises: lifecycleChartResultDataArray", lifecycleChartResultDataArray);
                        }
                        if (lifecycleChartResultDataArray.length > 0) {
                            const lastData = lifecycleChartResultDataArray[lifecycleChartResultDataArray.length - 1].chunkData;
                            const intervalStartTimeSec = lastData.intervalStartTimeSec;
                            const churnedUsersCohort = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(lifecycleChartResultDataArray, value => Array.from(value.chunkData.rawData.churnedUsersCohort))));
                            const resurrectedUsers = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(lifecycleChartResultDataArray, value => Array.from(value.chunkData.rawData.resurrectedUsers))));
                            const newUsers = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(lifecycleChartResultDataArray, value => Array.from(value.chunkData.rawData.newUsers))));
                            const churnedUsers = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(lifecycleChartResultDataArray, value => Array.from(value.chunkData.rawData.churnedUsers))));
                            const currentUsers = Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(lifecycleChartResultDataArray, value => Array.from(value.chunkData.rawData.currentUsers))));
                            const lifecycleResult = {
                                ok: {
                                    intervalStartTimeSec: intervalStartTimeSec,
                                    rawData: {
                                        churnedUsersCohort: churnedUsersCohort,
                                        resurrectedUsers: resurrectedUsers,
                                        newUsers: newUsers,
                                        churnedUsers: churnedUsers,
                                        currentUsers: currentUsers,
                                    }
                                }
                            };
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("getProjectLifecycleChunk lifecycleResult", lifecycleResult);
                            }
                            resolve(lifecycleResult);
                            return;
                        }
                        else {
                            console.warn("getProjectLifecycleChunk promises failure: no success results", tasksResult);
                            resolve({ err: { "temporarilyUnavailable": null } });
                            return;
                        }
                    }
                }
                catch (e) {
                    console.warn("getProjectLifecycleChunk failed", e);
                    resolve({ err: { "temporarilyUnavailable": null } });
                    return;
                }
            }
        });
    });
};
exports.getProjectLifecycleResultByChunks = getProjectLifecycleResultByChunks;
